import { Component } from '@angular/core';

@Component({
  selector: 'mav-horizontal-bar-graph-icon',
  templateUrl: './horizontal-bar-graph-icon.component.html',
  styleUrls: ['./horizontal-bar-graph-icon.component.scss']
})
export class HorizontalBarGraphIconComponent {

  constructor() { }
}
